import { Either, left, right } from "fp-ts/lib/Either";
import ShiftEntity from "../../../../domain/entities/ShiftEntity";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ShiftDto from "../../../dto/ShiftDto";

const CreateShiftApiImpl = async (_: { scheduleId: string, date: Date, userId: string }): Promise<Either<ErrorEntity, ShiftEntity>> => {
    try {
        const relativeUrl = "/turns/admin/create";
        const body = {
            "schedule_id": parseInt(_.scheduleId),
            "valet_ids": [parseInt(_.userId)],
            "date": _.date.toISOString().split('T')[0]
        };
        const response = await di.get<HostApi>(HostApiName).post(relativeUrl, body);

        const parsed: ShiftEntity = ShiftDto.fromJSON(response.valet_turns[0]);
        return right(parsed);
    } catch (error) {
        return left(ErrorEntityFromError(error));
    }
}

export default CreateShiftApiImpl;